import { render, staticRenderFns } from "./RatingReviewsFilterWrapper.vue?vue&type=template&id=3d903c7d&"
import script from "./RatingReviewsFilterWrapper.vue?vue&type=script&lang=ts&"
export * from "./RatingReviewsFilterWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports